export enum AvailabilityOptionEnum {
    AlwaysAvailable = 1,
    AvailableEveningsAndWeekends = 2,
    WeekendAvailabilityOnly = 3,
    Other = 4
}